function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Fetch } from '@inface-sdk/common';
import { PushToken } from './token.abstract.class';
var targetDomainEnvs = {
  local: "http://alpha-sdk-push.mp.nexon.com",
  dev: "https://sandbox.api.nexon.com/toy-push/alpha",
  test: "https://sandbox.api.nexon.com/toy-push/qa",
  pre: "https://sandbox.api.nexon.com/toy-push/pre",
  live: "https://public.api.nexon.com/toy-push"
};
export var ToyPushTokenMeta = /*#__PURE__*/function () {
  function ToyPushTokenMeta() {
    _classCallCheck(this, ToyPushTokenMeta);
    this._gid = 'UNKNOWN_SERVICE_ID_VALUE';
    this._cid = 'UNKNOWN_CID_VALUE';
    this._country = 'KR';
    this._loc = 'ko_KR';
    this._iasToken = 'UNKNOWN_IAS_TOKEN';
    this._platform = typeof window !== 'undefined' ? '8' : '4';
    this._serverAlias = '';
    this._env = 'live';
  }
  return _createClass(ToyPushTokenMeta, [{
    key: "env",
    value: function env() {
      var _envValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'live';
      this._env = _envValue;
      return this;
    }
  }, {
    key: "gid",
    value: function gid() {
      var _gidValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UNKNOWN_SERVICE_ID_VALUE';
      this._gid = String(_gidValue);
      return this;
    }
  }, {
    key: "cid",
    value: function cid() {
      var _cidValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UNKNOWN_CID_VALUE';
      this._cid = _cidValue;
      return this;
    }
  }, {
    key: "country",
    value: function country() {
      var _countryValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'KR';
      this._country = _countryValue;
      return this;
    }
  }, {
    key: "loc",
    value: function loc() {
      var _locValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ko_KR';
      this._loc = _locValue;
      return this;
    }
  }, {
    key: "webToken",
    value: function webToken() {
      var _webTokenValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UNKNOWN_IAS_TOKEN';
      this._iasToken = _webTokenValue;
      return this;
    }
  }, {
    key: "serverAlias",
    value: function serverAlias() {
      var _serverAliasValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this._serverAlias = _serverAliasValue;
      return this;
    }
  }, {
    key: "toPayload",
    value: function toPayload() {
      return {
        gid: this._gid,
        cid: this._cid,
        country: this._country,
        loc: this._loc,
        iasToken: this._iasToken,
        platform: this._platform,
        serverAlias: this._serverAlias,
        env: this._env
      };
    }
  }, {
    key: "build",
    value: function build() {
      return new ToyPushToken(this.toPayload());
    }
  }]);
}();
export var ToyPushToken = /*#__PURE__*/function (_PushToken) {
  function ToyPushToken(_ref) {
    var _this;
    var gid = _ref.gid,
      deviceID = _ref.deviceID,
      _ref$country = _ref.country,
      country = _ref$country === void 0 ? 'KR' : _ref$country,
      _ref$loc = _ref.loc,
      loc = _ref$loc === void 0 ? 'ko_KR' : _ref$loc,
      iasToken = _ref.iasToken,
      cid = _ref.cid,
      platform = _ref.platform,
      env = _ref.env,
      serverAlias = _ref.serverAlias;
    _classCallCheck(this, ToyPushToken);
    _this = _callSuper(this, ToyPushToken);
    _this._baseDomain = env && targetDomainEnvs[env] ? targetDomainEnvs[env] : targetDomainEnvs['live'];
    _this._hasRegistered = false;
    _this._env = env;
    _this._gid = gid;
    _this._cid = cid;
    _this._ldid = deviceID || cid || 'UNKNOWN_LDID_VALUE'; // =  웹버전에서 CID사용
    _this._udid = deviceID || cid || 'UNKNOWN_UDID_VALUE'; // =  웹버전에서 CID사용
    _this._country = country;
    _this._loc = loc;
    _this._npToken = iasToken; // web 버전은 insign의 web token을 사용하기로 함
    _this._appId = '';
    _this._pushToken = cid;
    _this._serverAlias = serverAlias;
    _this._lscid = [cid, serverAlias].join(':');
    _this._platform = platform || typeof window !== 'undefined' ? '8' : '4'; // = 1,2 = 모바일, 4 = Desktop, 8 = Web
    return _this;
  }
  _inherits(ToyPushToken, _PushToken);
  return _createClass(ToyPushToken, [{
    key: "type",
    get: function get() {
      return 'ToyPushToken';
    }
  }, {
    key: "env",
    get: function get() {
      return this._env || 'live';
    }
  }, {
    key: "hasRegistered",
    get: function get() {
      return this._hasRegistered;
    }
  }, {
    key: "register",
    value: function () {
      var _register = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Fetch("".concat(this._baseDomain, "/sdk/push/token/im/web"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.toPayload())
              });
            case 3:
              response = _context.sent;
              if (!(response.status === 200)) {
                _context.next = 8;
                break;
              }
              this._hasRegistered = true;
              _context.next = 9;
              break;
            case 8:
              throw new Error(JSON.stringify(response));
            case 9:
              _context.next = 16;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              this._hasRegistered = false;
              throw new Error(_context.t0);
            case 16:
              return _context.abrupt("return", this._hasRegistered);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 11]]);
      }));
      function register() {
        return _register.apply(this, arguments);
      }
      return register;
    }()
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        hasRegistered: this._hasRegistered,
        env: this._env,
        gid: this._gid,
        cid: this._cid,
        ldid: this._ldid,
        udid: this._udid,
        country: this._country,
        loc: this._loc,
        npToken: this._npToken,
        npTokenType: 'web_token',
        appId: this._appId,
        pushToken: [this._cid, this._serverAlias].join(':'),
        serverAlias: this._serverAlias,
        platform: this._platform
      };
    }

    /**
     * https://jiradev.nexon.com/browse/INFACE-1591
     *
     * @return {object} toy push token 등록을 위한 payload 변환
     * @memberof ToyPushToken
     */
  }, {
    key: "toPayload",
    value: function toPayload() {
      return {
        svcID: this._gid,
        ldid: this._ldid,
        udid: this._udid,
        country: this._country,
        loc: this._loc,
        npToken: this._npToken,
        appId: this._appId,
        pushToken: [this._cid, this._serverAlias].join(':'),
        platform: this._platform
      };
    }
  }]);
}(PushToken);